export const ru = {
    'relevance-match': 'автотаргетинг'
};
